"use client";
import { Card, CardContent, CardHeader } from "../../../components/ui/card";
import { cn } from "../../../helper/utilityHelper";
import { Icon } from "@iconify/react";
import Utility from "../../../helper/utilityHelper";

const ReportsArea = ({ bookingSummary }) => {
  const reports = [
    {
      id: 1,
      name: "Total Bookings",
      count: Utility.formatNumber(bookingSummary?.totalBookings),
      rate: Utility.formatNumber(bookingSummary?.totalBookingHours),
      isUp: true,
      icon: (
        <Icon icon="heroicons:calendar-days-20-solid" className="h-5 w-5" />
      ),
      color: "primary",
      bgColor: "#0b1a39",
    },
    {
      id: 2,
      name: "App Bookings",
      count: Utility.formatNumber(bookingSummary?.appBookings),
      rate: Utility.formatNumber(bookingSummary?.appBookingHours),
      isUp: true,
      icon: (
        <Icon icon="heroicons:device-phone-mobile-solid" className="h-5 w-5" />
      ),
      color: "info",
      bgColor: "#0b1a39",
    },
    {
      id: 3,
      name: "Club Bookings",
      count: Utility.formatNumber(bookingSummary?.clubBookings),
      rate: Utility.formatNumber(bookingSummary?.clubBookingHours),
      isUp: true,
      icon: <Icon icon="heroicons:trophy-solid" className="h-5 w-5" />,
      color: "warning",
      bgColor: "#3359ba",
    },
    ...(global?.myClub?.isownapp
      ? [
          {
            id: 4,
            name: "My App Bookings",
            count: Utility.formatNumber(bookingSummary?.myAppBookings),
            rate: Utility.formatNumber(bookingSummary?.myAppBookingHours),
            isUp: true,
            icon: <Icon icon="heroicons:star-solid" className="h-5 w-5" />,
            color: "success",
            bgColor: "#00ff00",
          },
        ]
      : []),
    ...(global?.myClub?.isownweb
      ? [
          {
            id: 5,
            name: "Web Bookings",
            count: Utility.formatNumber(bookingSummary?.webBookings),
            rate: Utility.formatNumber(bookingSummary?.webBookingHours),
            isUp: true,
            icon: (
              <Icon
                icon="heroicons:computer-desktop-solid"
                className="h-5 w-5"
              />
            ),
            color: "success",
            bgColor: "#e400f8ff",
          },
        ]
      : []),
    ...(global?.myClub?.isownwhatsapp
      ? [
          {
            id: 6,
            name: "WhatsApp Bookings",
            count: Utility.formatNumber(bookingSummary?.whatsappBookings),
            rate: Utility.formatNumber(bookingSummary?.whatsappBookingHours),
            isUp: true,
            icon: (
              <Icon
                icon="heroicons:chat-bubble-left-solid"
                className="h-5 w-5"
              />
            ),
            color: "success",
            bgColor: "#12b3d4ff",
          },
        ]
      : []),

    {
      id: 7,
      name: "Cancelled Bookings",
      count: Utility.formatNumber(bookingSummary?.cancelledBookings),
      rate: Utility.formatNumber(bookingSummary?.cancelledBookingHours),
      isUp: false,
      icon: <Icon icon="heroicons:x-mark-solid" className="h-5 w-5" />,
      color: "destructive",
      bgColor: "#ef4444",
    },
     {
      id: 8,
      name: "Net Bookings",
      count: Utility.formatNumber(bookingSummary?.netBookings),
      rate: Utility.formatNumber(bookingSummary?.netBookingHours),
      isUp: true,
      icon: (
        <Icon icon="heroicons:calculator-20-solid" className="h-5 w-5 text-green-600" />
      ),
      color: "success",
      bgColor: "#0b1a39",
    },
  ];
  return (
    <>
      <div className="flex flex-wrap gap-4">
        {reports.map((item, index) => (
          <Card key={`report-card-${index}`} className="flex-1 min-w-0">
            <CardHeader className="flex-col-reverse sm:flex-row flex-wrap gap-2  border-none mb-0 pb-0">
              <span className="text-sm font-medium text-default-900 flex-1">
                {item.name}
              </span>
              <span
                className={cn(
                  "flex-none h-9 w-9 flex justify-center items-center bg-default-100 rounded-full",
                  {
                    "bg-primary bg-opacity-10 text-primary":
                      item.color === "primary",
                    "bg-info bg-opacity-10 text-info": item.color === "info",
                    "bg-warning bg-opacity-10 text-warning":
                      item.color === "warning",
                    "bg-destructive bg-opacity-10 text-destructive":
                      item.color === "destructive",
                  }
                )}
              >
                {item.icon}
              </span>
            </CardHeader>
            <CardContent className="pb-4 px-4">
              <div className="text-2xl font-semibold text-default-900 mb-2.5">
                {item.count}
              </div>
              <div className="flex items-center font-semibold gap-1">
                {item.isUp ? (
                  <>
                    <span className="text-success">{item.rate} Hours</span>
                    {/* <Icon
                      icon="heroicons:arrow-trending-up-16-solid"
                      className="text-success text-xl"
                    /> */}
                  </>
                ) : (
                  <>
                    <span className="text-destructive">{item.rate} Hours</span>
                    {/* <Icon
                      icon="heroicons:arrow-trending-down-16-solid"
                      className="text-destructive text-xl"
                    /> */}
                  </>
                )}
              </div>
              {/* <div className="mt-1 text-xs text-default-600">
                vs Previous 30 Days
              </div> */}
            </CardContent>
          </Card>
        ))}
      </div>
    </>
  );
};

export default ReportsArea;

